import type { FilterItem } from '@wconcept/wconcept-common/models/renewal/common';
import type { LpProductPriceRange } from '@apis/renewal/lpProduct';
import numberToKorean, {
  FormatOptions,
} from '@wconcept/wconcept-common/utils/numberToKorean';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import FltPriceBox from '@wconcept/wconcept-ui-renewal/src/components/organisms/_list/FltPriceBox';
import { useCallback, useEffect, useState } from 'react';
import { getLpProductV2PriceDomain } from '../filterV2';

const getSelectedPriceValue = (selectedPrice: FilterItem): number[] =>
  Array.isArray(selectedPrice.value)
    ? selectedPrice.value.filter(
        (value): value is number => typeof value === 'number'
      )
    : [];

interface PriceContentV2Props {
  readonly selectedPrice: FilterItem;
  readonly priceRange?: LpProductPriceRange | null;
  readonly onChangePrice: (price: FilterItem) => void;
}

function PriceContentV2({
  selectedPrice,
  priceRange,
  onChangePrice,
}: PriceContentV2Props): React.JSX.Element {
  const [isFirst, setIsFirst] = useState(true);
  const [priceValue, setPriceValue] = useState<number[]>([]);
  const [domain, setDomain] = useState<number[]>([]);

  useEffect(() => {
    if (isFirst && priceRange) {
      setDomain(getLpProductV2PriceDomain(priceRange));
      setIsFirst(false);
    }
  }, [isFirst, priceRange]);

  useEffect(() => {
    if (selectedPrice.value) {
      setPriceValue(getSelectedPriceValue(selectedPrice));
    } else if (priceRange) {
      setPriceValue(getLpProductV2PriceDomain(priceRange));
    }
  }, [selectedPrice, priceRange]);

  const onPriceChange = useCallback(
    (values: number[]) => {
      const [min, max] = values;
      if (max === domain[0] && min === domain[1]) return;

      const minValue =
        min !== domain[0]
          ? `${numberToKorean(Number(min), FormatOptions.MIXED_NUMBER)}원`
          : '';
      const maxValue =
        max !== domain[1]
          ? `${numberToKorean(Number(max), FormatOptions.MIXED_NUMBER)}원`
          : '';

      const price = {
        code: 'price',
        type: 'price',
        filterType: 'priceRange',
        name: minValue || maxValue ? `${minValue} ~ ${maxValue}` : '',
        value: values,
      };

      onChangePrice(price);
    },
    [domain, onChangePrice]
  );

  return (
    <Box className="coner-price">
      <FltPriceBox
        title="가격 범위 설정"
        subTitle="가격은 천원단위로 입력해주세요."
        domain={domain}
        values={priceValue}
        onValues={(values: number[]) => {
          setPriceValue(values);
          onPriceChange(values);
        }}
      />
    </Box>
  );
}

export default PriceContentV2;
